import "core-js/modules/es.string.starts-with";
import React from 'react';
import { useLocation } from 'react-router-dom';
import classnames from 'classnames';
import { Link } from "./..";
import { useLanguage } from "../../../i18n";
import styles from './NavLink.scss';

var NavLink = function NavLink(_ref) {
  var children = _ref.children,
      className = _ref.className,
      activeClassName = _ref.activeClassName,
      to = _ref.to,
      onActiveNavLinkClick = _ref.onActiveNavLinkClick;

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var _useLanguage = useLanguage(),
      toLocalizedRoute = _useLanguage.toLocalizedRoute;

  var isLinkActive = pathname.startsWith(toLocalizedRoute(to));
  return isLinkActive ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classnames(styles.navLinkActive, className, activeClassName),
    onClick: onActiveNavLinkClick
  }, children) : /*#__PURE__*/React.createElement(Link, {
    to: toLocalizedRoute(to),
    className: className
  }, children);
};

export default NavLink;